import { createFileRoute } from "@tanstack/react-router";
import { RoofingServicePage } from "@/components/RoofingServicePage";
import { roofingSystemPages } from "@/data/roofingSystemContent";

const c = roofingSystemPages["architectural-sheet-metal"];

export const Route = createFileRoute("/services/architectural-sheet-metal")({
  head: () => ({
    meta: [
      { title: "Architectural Sheet Metal Southern California | McKay Roofing & Solar" },
      { name: "description", content: c.heroSubtitle },
      { property: "og:title", content: "Architectural Sheet Metal - McKay Roofing & Solar" },
      { property: "og:description", content: c.heroSubtitle },
      { property: "og:type", content: "website" },
    ],
    links: [{ rel: "canonical", href: "https://mckay.steadyautogrowthdemo.com/services/architectural-sheet-metal" }],
  }),
  component: () => <RoofingServicePage {...c} />,
});
